import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=919a091c&scoped=true"
import script from "./baseDialog.vue?vue&type=script&lang=js"
export * from "./baseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919a091c",
  null
  
)

export default component.exports